import { isAxiosError } from "axios";
import { HttpStatusCode } from "../../legacy/common/http-status-code";

export function isAuthError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === HttpStatusCode.UNAUTHORIZED;
}
